'use strict';
import analytics from './analytics';

const miniCrossSellRecommendations = async () => {
    // Polling function to wait for the recommendations container to appear
    const waitForRecommendations = () => {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                const miniCrossSellRecommendations = $('.mini-recommendation-container .minicross-sell-recommendations');
                const $crossSellWrapper = $(".mini-cross-sell-wrapper");
                const $productWrapper = $(".product-details-wrapper");
                if (miniCrossSellRecommendations.length) {
                    clearInterval(interval);
                    resolve(miniCrossSellRecommendations);
                    $crossSellWrapper.show();
                    $productWrapper.addClass("pdp-cross-sell-active");
                    analytics.minicrosssellPDPonInit(miniCrossSellRecommendations);
                }
            }, 500); // Check every 500ms
        });
    };
    // Wait for the recommendations container to appear
    const miniCrossSellRecommendations = await waitForRecommendations();

    if (!$(miniCrossSellRecommendations).hasClass("slick-initialized")) {
        $(miniCrossSellRecommendations).slick({
            initialSlide: 0,
            autoplay: false,
            dots: false,
            arrows: true,
            swipe: true,
            infinite: false,
            speed: 150,
            slidesToShow: 1,
            swipeToSlide: 1,
            fade: false,
            cssEase: 'linear',
            variableWidth: true,
            nextArrow: '<div class="slick-next"><i class="icon icon-rightCarrot"></i></div>',
            prevArrow: '<div class="slick-prev"><i class="icon icon-leftCarrot"></i></div>'
        });
        analytics.minicrosssellPDPafterInit(miniCrossSellRecommendations);
    }

};

$(window).on('load', function() {
    const $crossSellWrapper = $(".mini-cross-sell-wrapper");
    const $productWrapper = $(".product-details-wrapper");
    if ($('.mini-cross-sell-wrapper div[id^="cq_recomm_slot"]').is(":empty")) {
        $crossSellWrapper.hide();
        $productWrapper.removeClass("pdp-cross-sell-active");
    }
});

/**
 * @function init
 * @description Initializes Mini cross sell
 */
export default {
    init: function () {
        miniCrossSellRecommendations();
    }
};